import { type EntityId, type EntityState } from '@reduxjs/toolkit'
import React, { useEffect, useState } from 'react'
import { type ExperienceCard } from '../../types/types'
import { StudentContainer } from './experienceListPresentation.styles'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow
} from '@mui/material'
import ExperienceListItemPresentation from './ExperienceListItemPresentation'
import images from '../../../../constants/images/images'
import { useAppSelector } from '../../../../app/hooks'
import { experienceMetadataSelected } from '../../api/experienceSlice'
import { closestCenter, DndContext, DragEndEvent, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { useUpdatePositionMutation } from '../../api/experienceCardApiSlice'

interface ExperienceListPresentationPorps {
  list: EntityState<ExperienceCard>
  onEdit: (id: EntityId) => void
  onPlus: (id: EntityId) => void
  onReview: (id: EntityId) => void
  onDelete: (id: EntityId) => void
  onSort: (fieldName: string) => void
  sort: string
  page?: number
  limit?: number
  onPage?: (pageNumber: number) => void
  onLimit?: (limitNumber: number) => void
}
const ExperienceListPresentation: React.FC<ExperienceListPresentationPorps> = ({
  list,
  onEdit,
  onPlus,
  onReview,
  onSort,
  sort,
  page,
  limit,
  onPage,
  onDelete,
  onLimit
}) => {
  const experienceMeta: any = useAppSelector(experienceMetadataSelected);
  const [items,setItems] = useState<ExperienceCard[]>([]);
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor,{
      coordinateGetter:sortableKeyboardCoordinates
    })
  )

  const [updatePosition,{isSuccess,isError,isLoading}] = useUpdatePositionMutation()

  useEffect(() => {
    if(list){
      setItems(Object.values(list.entities) as ExperienceCard[]);
    }
  },[list])

  const handleDragEnd = async (event:DragEndEvent) => {
    const {active,over } = event;
    if(over && active.id !== over.id){
      setItems((items) => {
        const oldIndex = items.findIndex((item) => item._id === active.id);
        console.log("old one", oldIndex)
        const newIndex = items.findIndex((item) => item._id === over.id)
        console.log("new One",newIndex)

        console.log("active id",active.id)
        console.log('over id', over.id);
        (async () => 
          await updatePosition({oldID:active.id  , newID:over.id, oldPositon:oldIndex,newPositon:newIndex }).unwrap()
        )()
        return arrayMove(items,oldIndex,newIndex)
      })
    }
  }

  return (
    <StudentContainer>
      <div
        style={{
          width: '100%',
          marginTop: -40,
          background: 'white',
          paddingTop: '15px',
          boxShadow: '0 10px 20px rgba(18, 38, 63, 0.03)'
        }}
      >
        <Table style={{ overflow: 'visible', position: 'relative' , borderCollapse: 'separate' , paddingLeft:30,
    borderSpacing: '0em 11px',  borderTop: "1px solid #EFF2F7" }}>
          <TableHead>
            <TableRow>
            <TableCell style={{ borderBottom: 'none', padding: '0 16px 10px 16px' }}></TableCell>
            <TableCell style={{ borderBottom: 'none' , padding: '0 16px 10px 16px' }}></TableCell>
              <TableCell style={{ borderBottom: 'none', padding: '0 16px 10px 16px' }}></TableCell>
              <TableCell style={{ borderBottom: 'none' , padding: '0 16px 10px 16px' }}></TableCell>
              <TableCell
                style={{ cursor: 'pointer' , borderBottom: 'none', padding: '0 16px 10px 16px' }}
                onClick={() => {
                  onSort('title')
                }}
              >
                <div
                  style={{
                    maxWidth: 120,
                    textAlign: 'center',
                    fontSize: 13,
                    justifyContent: 'center',
                    fontWeight: 600,
                    fontFamily: 'Poppins',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  Title{' '}
                  {sort !== '-title' && sort !== 'title'
                    ? (
                    <img style={{ marginLeft: 4 }} src={images.unSelectIcon} />
                  ) : sort?.startsWith("-title") ? (
                    <img style={{ marginLeft: 4 }} src={images.BottomIcon} />
                        )
                      : (
                          sort === 'title' && (
                      <img style={{ marginLeft: 4 }} src={images.topIcon} />
                          )
                        )}
                </div>
              </TableCell>
              <TableCell
                style={{ cursor: 'pointer' , borderBottom: 'none', padding: '0 16px 10px 16px'  }}
                onClick={() => {
                  onSort('description')
                }}
              >
                <div
                  style={{
                    maxWidth: 370,
                    textAlign: 'center',
                    fontSize: 13,
                    justifyContent: 'center',
                    fontWeight: 600,
                    fontFamily: 'Poppins',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  Description
                  {sort !== '-description' && sort !== 'description'
                    ? (
                    <img style={{ marginLeft: 4 }} src={images.unSelectIcon} />
                  ) : sort?.startsWith("-description") ? (
                    <img style={{ marginLeft: 4 }} src={images.BottomIcon} />
                        )
                      : (
                          sort === 'description' && (
                      <img style={{ marginLeft: 4 }} src={images.topIcon} />
                          )
                        )}
                </div>
              </TableCell>
              <TableCell
                style={{ cursor: 'pointer',borderBottom: 'none' , padding: '0 16px 10px 16px'  }}
                onClick={() => {
                  onSort('startDate')
                }}
              >
                <div
                  style={{
                    maxWidth: 120,
                    textAlign: 'center',
                    fontSize: 13,
                    justifyContent: 'center',
                    fontWeight: 600,
                    fontFamily: 'Poppins',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  Duration{' '}
                  {sort !== '-startDate' && sort !== 'startDate'
                    ? (
                    <img style={{ marginLeft: 4 }} src={images.unSelectIcon} />
                  ) : sort?.startsWith("-startDate") ? (
                    <img style={{ marginLeft: 4 }} src={images.BottomIcon} />
                        )
                      : (
                          sort === 'startDate' && (
                      <img style={{ marginLeft: 4 }} src={images.topIcon} />
                          )
                        )}
                </div>
              </TableCell>
              <TableCell style={{ cursor: 'pointer',borderBottom: 'none' , padding: '0 16px 10px 16px'  }} onClick={() => {}}>
                <div
                  style={{
                    maxWidth: 120,
                    textAlign: 'center',
                    fontSize: 13,
                    justifyContent: 'center',
                    fontWeight: 600,
                    fontFamily: 'Poppins',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  Location{' '}
                  {sort !== '-' && sort !== ''
                    ? (
                    <img style={{ marginLeft: 4 }} src={images.unSelectIcon} />
                  ) : sort?.startsWith("-") ? (
                    <img style={{ marginLeft: 4 }} src={images.BottomIcon} />
                        )
                      : (
                          sort === '' && (
                      <img style={{ marginLeft: 4 }} src={images.topIcon} />
                          )
                        )}
                </div>
              </TableCell>
              <TableCell
                style={{ cursor: 'pointer', borderBottom: 'none', padding: '0 16px 10px 16px'  }}
                onClick={() => {
                  onSort('xpCompletion')
                }}
              >
                <div
                  style={{
                    maxWidth: 120,
                    textAlign: 'center',
                    fontSize: 13,
                    justifyContent: 'center',
                    fontWeight: 600,
                    fontFamily: 'Poppins',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  Xp{' '}
                  {sort !== '-xpCompletion' && sort !== 'xpCompletion'
                    ? (
                    <img style={{ marginLeft: 4 }} src={images.unSelectIcon} />
                  ) : sort?.startsWith("-xpCompletion") ? (
                    <img style={{ marginLeft: 4 }} src={images.BottomIcon} />
                        )
                      : (
                          sort === 'xpCompletion' && (
                      <img style={{ marginLeft: 4 }} src={images.topIcon} />
                          )
                        )}
                </div>
              </TableCell>
              <TableCell
                style={{ cursor: 'pointer' , borderBottom: 'none', padding: '0 16px 10px 16px'  }}
                onClick={() => {
                  onSort('experienceType.title')
                }}
              >
                <div
                  style={{
                    maxWidth: 120,
                    textAlign: 'center',
                    fontSize: 13,
                    justifyContent: 'center',
                    fontWeight: 600,
                    fontFamily: 'Poppins',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  Type{' '}
                  {sort !== '-experienceType.title' &&
                  sort !== 'experienceType.title'
                    ? (
                    <img style={{ marginLeft: 4 }} src={images.unSelectIcon} />
                  ) : sort?.startsWith("-experienceType.title") ? (
                    <img style={{ marginLeft: 4 }} src={images.BottomIcon} />
                        )
                      : (
                          sort === 'experienceType.title' && (
                      <img style={{ marginLeft: 4 }} src={images.topIcon} />
                          )
                        )}
                </div>
              </TableCell>
              <TableCell
                style={{ cursor: 'pointer' , borderBottom: 'none', padding: '0 16px 10px 16px' }}
                onClick={() => {
                  onSort('completionType.title')
                }}
              >
                <div
                  style={{
                    maxWidth: 120,
                    textAlign: 'center',
                    fontSize: 13,
                    justifyContent: 'center',
                    fontWeight: 600,
                    fontFamily: 'Poppins',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  Completion{' '}
                  {sort !== '-completionType.title' &&
                  sort !== 'completionType.title'
                    ? (
                    <img style={{ marginLeft: 4 }} src={images.unSelectIcon} />
                  ) : sort?.startsWith("-completionType.title") ? (
                    <img style={{ marginLeft: 4 }} src={images.BottomIcon} />
                        )
                      : (
                          sort === 'completionType.title' && (
                      <img style={{ marginLeft: 4 }} src={images.topIcon} />
                          )
                        )}
                </div>
              </TableCell>
              <TableCell style={{ borderBottom: 'none', padding: '0 16px 10px 16px' }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* {list.ids.map((id) => (
              <ExperienceListItemPresentation
              key={id}
                item={list!.entities[id]!}
                onEdit={onEdit}
                onPlus={onPlus}
                onReview={onReview}
                onDelete={onDelete}
                list={list}
              />
            ))} */}

            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
            >
              <SortableContext items={items.map(item => item._id)} strategy={verticalListSortingStrategy}>
              {items.map((item) => (
               <ExperienceListItemPresentation
               key={item._id}
                 item={item}
                 onEdit={onEdit}
                 onPlus={onPlus}
                 onReview={onReview}
                 onDelete={onDelete}
                 list={list}
               />
              ))}
              </SortableContext>
            </DndContext>
          </TableBody>
        </Table>
        {experienceMeta[0]?.toatlCount > 24 && (
          <TablePagination
            rowsPerPageOptions={[25, 50, 100]}
            component="div"
            count={experienceMeta[0]?.toatlCount}
            rowsPerPage={limit!}
            page={page! - 1}
            onPageChange={(event: unknown, newPage: number) => {
              onPage!(newPage + 1)
            }}
            onRowsPerPageChange={(
              event: React.ChangeEvent<HTMLInputElement>
            ) => {
              onLimit!(parseInt(event.target.value, 10))
            }}
          />
        )}
      </div>
    </StudentContainer>
  )
}
// this is test
export default ExperienceListPresentation
